<template>
  <div>
    <STable
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
    ></STable>
  </div>
</template>

<script>
export default {
  name: "TestTable",
  data() {
    return {
      url: "/user/page",
      columns: [
        {
          label: "登录名",
          prop: "loginName"
        }
      ],
      handles: {
        width: 200,
        btns: [
          {
            label: "操作",
            url: "/config/ahaProfitConfig",
            method: "get", //默认get get|put|post|delete 当url不为空时设置
            before: function(index, record) {
              //当url不为空时设置
              return record;
            },
            handle: function(resp) {}
          }
        ]
      },
      query: [
        {
          label: "123123",
          prop: "222",
          placeholder: "请输入",
          type: "city"
        },
        {
          label: "文本框",
          prop: "loginName",
          placeholder: "请输入"
        },
        {
          label: "下拉框",
          prop: "select",
          placeholder: "请选择状态",
          type: "select",
          data: [{ label: "A", value: "1" }]
        },
        {
          label: "日期",
          prop: "date",
          placeholder: "请选择日期",
          type: "date",
          option: {
            type: "datetime"
          }
        },
        {
          label: "开关",
          prop: "switch",
          placeholder: "请选择状态",
          type: "switch"
        }
      ],
      toolbar: [
        {
          label: "增加",
          type: "primary",
          handle: function(resp) {
            alert(123);
          }
        },
        {
          label: "删除",
          type: "danger",
          isSelectRowShow: true,
          url: "/config/ahaProfitConfig",
          method: "get", //默认get get|put|post|delete 当url不为空时设置
          before: function(records) {
            //当url不为空时设置
            return { id: "123123123" };
          },
          handle: function(resp) {}
        }
      ]
    };
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/TestTable.vue